import React, { useState } from "react";
import TakisDropdown from "./TakisDropdown";
import LanguageToggle from "./TakisLanguageToggle";
import { HamButton, useStyles } from "./TakisNav.styles";
import { MenuSvg } from "./TakisSvgs";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useLanguage, supportedLanguages } from "../hooks/useLanguage";
import SearchBox from "./TakisSearchBox";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const Nav = ({ data, width, setMenuHeight }) => {
  const classes = useStyles();
  const [isNavOpen, setIsNavOpen] = useState(true);
  const navActivated = isWidthUp("lg", width);
  const language = useLanguage();
  const theme = useTheme();

  const mainToggleTitle = language === supportedLanguages.en
    ? 'Main'
    : 'Principal';

  const handleClick = () => {
    setIsNavOpen(!isNavOpen);
    if (isNavOpen) {
      window.scrollTo(0, 0);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const onMobile = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.lg)
  );

  const onSearching = () => {
    if (onMobile) {
      setIsNavOpen(!isNavOpen);
      if (isNavOpen) {
        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    }
  }

  return (
    // full width Header
    <header className={classes.navWrapper}>

      {/* Center items on full width header */}
      <div className={classes.navCenter}>
        <nav
          className={classes.navLimit}
          aria-label="main"
          >

          {/* Logo */}
          <Link
            className={classes.logo_link}
            aria-label={data.main_button.aria_label}
            to={(language === supportedLanguages.en) ? '/' : '/es'}
            onClick={() => setIsNavOpen(true)}
          >
            <img
              src={data.main_button.image_url}
              alt={data.main_button.alt}
              className={classes.takisLogo}
            />
          </Link>

          {/* Mobile Hamburger */}
          <HamButton
            className={classes.nav_button}
            title={mainToggleTitle}
            aria-controls="mobile-menu"
            aria-expanded={onMobile ? !(isNavOpen || navActivated) : null}
            onClick={handleClick}
          >
            <MenuSvg state={isNavOpen} svg_class={classes.barsIcon}></MenuSvg>
            <span
              className="sr-only"
              >
              {isNavOpen ? 'Open Menu' : 'Close Menu'}
            </span>
          </HamButton>

          {/* cover */}
          <div
            className={`
              ${classes.screen_cover}
              ${
                isNavOpen || navActivated
                  ? ""
                  : classes.screen_cover_on
              }
            `}
          />
          {/* NAV BAR */}
          <ul
            id="mobile-menu"
            className={
              isNavOpen || navActivated
                ? classes.navbar
                : `${classes.navbar} ${classes.navbar_open}`
            }
            >
            {/*
              SEARCH
              Mobile Duplicated here for tab navigation issues
            */}
            {
              onMobile &&
              <li className={classes.listItemLink}>
                <SearchBox
                  onSearching={onSearching}
                  searchConfig={data.search_field}
                  />
              </li>
            }
            {data.nav_options.map((item, index) => {
              const visible = item.visible;
              if (visible) {
                if (item.sub_nav_options.length === 0) {
                  return (
                    <li
                      className={classes.listItemLink}
                      key={item.title + `_${index}`}
                      >
                      <Link
                        key={item.id}
                        className={`${classes.nav_options} ${classes.menu_link}`}
                        to={item.link}
                        onClick={!navActivated ? handleClick : undefined}
                      >
                        {item.title}
                      </Link>
                    </li>
                  );
                } else {
                  return (
                    <li
                      className={classes.listItemLink}
                      key={item.id}
                      >
                      <TakisDropdown
                        itemId={item.id}
                        title={item.title}
                        showImages={item.show_images}
                        setMenuHeight={setMenuHeight}
                        link={item.link}
                        linkType={item.type}
                        options={item.sub_nav_options}
                        clickFunc={!navActivated ? handleClick : undefined}
                        />
                    </li>
                  );
                }
              }
              return false
            })}

            {/* LANGUAGE */}
            <li className={classes.listItemLink}>
              <LanguageToggle
                />
            </li>

            {/*
              SEARCH
              Desktop Duplicated here for tab navigation issues
            */}
            {
              !onMobile &&
              <li className={classes.listItemLink}>
                <SearchBox
                  onSearching={onSearching}
                  searchConfig={data.search_field}
                  />
              </li>
            }
          </ul>
        </nav>
      </div>
    </header>
  );
};

Nav.propTypes = {
  data: PropTypes.object,
};

export default withWidth()(Nav);
